import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  size?: 'lg' | 'sm';
}
const pad = (n: number) => String(n).padStart(2, '0');
function FlipDigit({
  value,
  label,
  size
}: {
  value: number;
  label: string;
  size: 'lg' | 'sm';
}) {
  const isLg = size === 'lg';
  return <div className="flex flex-col items-center" data-id="element-17">
      <div className={`relative overflow-hidden rounded-lg border border-orange bg-carbon-3 ${isLg ? 'h-20 w-20 sm:h-28 sm:w-28' : 'h-12 w-12'} flex items-center justify-center`} data-id="element-18">
        <AnimatePresence mode="popLayout" initial={false} data-id="element-19">
          <motion.span key={value} initial={{
          y: '-100%',
          opacity: 0
        }} animate={{
          y: '0%',
          opacity: 1
        }} exit={{
          y: '100%',
          opacity: 0
        }} transition={{
          duration: 0.35,
          ease: 'easeInOut'
        }} className={`font-display font-extrabold text-white tabular-nums ${isLg ? 'text-4xl sm:text-6xl' : 'text-xl'}`} data-id="element-20">
            {pad(value)}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className={`mt-2 font-heading font-bold uppercase tracking-widest text-orange ${isLg ? 'text-xs sm:text-sm' : 'text-[10px]'}`} data-id="element-21">
        {label}
      </span>
    </div>;
}
export function CountdownTimer({
  size = 'lg'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const isLg = size === 'lg';
  return <div className={`flex items-end justify-center ${isLg ? 'gap-3 sm:gap-5' : 'gap-1.5'}`} role="timer" aria-label={`Oferta termina en ${hours} horas ${minutes} minutos ${seconds} segundos`} data-id="element-22">
      <FlipDigit value={hours} label="hs" size={size} data-id="element-23" />
      <span className={`font-display font-extrabold text-orange pb-6 ${isLg ? 'text-4xl sm:text-6xl' : 'text-xl'}`} data-id="element-24">
        :
      </span>
      <FlipDigit value={minutes} label="min" size={size} data-id="element-25" />
      <span className={`font-display font-extrabold text-orange pb-6 ${isLg ? 'text-4xl sm:text-6xl' : 'text-xl'}`} data-id="element-26">
        :
      </span>
      <FlipDigit value={seconds} label="seg" size={size} data-id="element-27" />
    </div>;
}